import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {CALENDARDATAS_EMPTY, useCalendarDataMutations, useCalendarDatas} from "../api/calendardatasapi";
import {useCallback, useState} from "react";
import {ModalPopUp} from "../components/grouping/ModalPopUp";
import {ModalContentContainer} from "../components/grouping/ModalContentContainer";
import {Section} from "../components/grouping/Section";
import {Button, Col, Form, FormControl, FormLabel, FormSelect} from "react-bootstrap";
import {CustomEditor} from "../components/CustomEditor";
import {useForm} from "../utilities/formutilities";
import {CalendarCustom} from "../components/calendar/CalendarCustom";
import {CalendarTaskForm} from "../components/forms/CalendarTaskForm";


export function CalendarPage(props) {
    const [open, setOpen] = useState(false);
    const [taskEditing, setTaskEditing] = useState(undefined);

    const {calendardatas} = useCalendarDatas();
    return <BasePageLayout>
        <CalendarCustom small={false} onOpenChange={setOpen} onTaskEditingChange={setTaskEditing}
                        tasks={calendardatas}/>
        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<ModalContentContainer onOpenChanged={setOpen}>
                        <CalendarTaskForm onOpenChanged={setOpen} taskEditing={taskEditing}/>
                    </ModalContentContainer>}/>
    </BasePageLayout>
}

